const isInCart = (state, _id) => {
  const result = !!state.selectedItems.find((item) => item._id === _id);
  return result;
};

 const ValidationLogin=(data)=>{
  const errorsLogin={}

  //for email
  if(!data.email){
    errorsLogin.email="Email is requierd"
  }
  else if (!/\S+@\S+\.\S+/.test(data.email)){
    errorsLogin.email="Email is Inalid"

  }
  else{
    delete errorsLogin.email
  }
  //for password
  if(!data.password){
    errorsLogin.password="Password is requierd"
  }
  else if(data.password.length < 8){
    errorsLogin.password="Password be 6charecter or more"
  }
  else{
    delete errorsLogin.password
  }
  return errorsLogin
}
const SignUpValidation=(data)=>{
 const errorsSign={}
if(!data.fullName){
  errorsSign.fullName="fullName is requierd"
}
else if(data.fullName.length < 2){
  errorsSign.fullName="input your realy fullName"

}
else{
  delete errorsSign.fullName
}
//for emial
if(!data.email){
  errorsSign.email="Email is requierd"
}
else if (!/\S+@\S+\.\S+/.test(data.email)){
  errorsSign.email="Email is Inalid"

}
else{
  delete errorsSign.email
}
  //for password
  if(!data.password){
    errorsSign.password="Password is requierd"
  }
  else if(data.password.length < 8){
    errorsSign.password="Password be 6charecter or more"
  }
  else{
    delete errorsSign.password
  }
  //for confirm password
if(!data.rePassword){
  errorsSign.rePassword = "confirm the password"
}
else if(data.rePassword !==data.password){
  errorsSign.rePassword="password do not match"
}
else{
delete errorsSign.confirmPassword
}
//confirm phon number
if(!data.phoneNumber){
  errorsSign.phoneNumber="phone number is requierd"
}

else if(data.phoneNumber.length < 11){
  errorsSign.phoneNumber="Enter valid phone number"
}
else{
  delete errorsSign.phoneNumber
}
//for national _id
if(!data.nationalId){
  errorsSign.nationalId='National Id is requierd'

}
else{
  delete errorsSign.nationalId
}
return errorsSign
}
export { isInCart,ValidationLogin, SignUpValidation};
